import { delay } from 'redux-saga';
import { put } from 'redux-saga/effects';

import updateFetchKey from './updateFetchKey';
import updateFetchKeyDelayed from './updateFetchKeyDelayed';

export default function* sagaUpdateFetchKeyDelayed(action: ReturnType<typeof updateFetchKeyDelayed>) {
  // Delaying the update so we only force fetch once if there are many socket events related to the same key
  yield delay(1000);

  yield put(updateFetchKey(action.payload));
}
